import { render, staticRenderFns } from "./TransferredInvoice.vue?vue&type=template&id=6b9473e1&scoped=true&"
import script from "./TransferredInvoice.vue?vue&type=script&lang=js&"
export * from "./TransferredInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9473e1",
  null
  
)

export default component.exports